<template>
    <div v-drag.window-only class="reload-container">
        <div class="heading-section">
            <div class="update-message"><span class="update-msg">{{$t('Update')}}:</span></div>
            <div class="action-button-section">
                <span  class="btn btn-outline-secondary m-2" style="border: 1px solid rgb(88, 88, 88);" @click="ignoreNdHidePanel()">{{$t('Ignore')}}</span>
                <span class="center-pipe"></span>
                <button  class="btn btn-outline-primary" @click="updateSelectedComponent()">{{$t('Reload')}}</button>
            </div>
        </div>
        <div class="content-section">
            <span>{{$t(message)}}</span>
        </div>
    </div>
 </template>
 
 <script>
 import drag from '@branu-jp/v-drag';
 
 export default {
    name:'ReloadPanel',
    props:['message'],
    directives: {
       drag
    },
    methods:{
      ignoreNdHidePanel(){
          this.$emit('closeReloadPanel');
      },
      updateSelectedComponent(){
        this.$emit('reloadButtonClicked');
      }
    },
 }
 </script>
 
 <style lang="scss" scoped>
 $bg-color-on-hover: #22272b;
 $secondary-border-color: 1px solid #2b2b2b;
 $dull-text-color: #858585;
 $info-color:rgb(209, 210, 211);
 $info-font-size:15px;
 
 .reload-container{
     border-top: $secondary-border-color;
     background: $bg-color-on-hover;
     box-shadow: 1px 2px 32px 4px rgba(0,0,0,0.63);
     padding: 4px;
     border-radius: 6px;
     display: flex;
     flex-direction: column;
     width: 357px;
     position: fixed;
     bottom: 16px;
     z-index: 99999;
     inset-inline-start: 26px;
     max-width:357px;
     max-height: fit-content;
     text-align: start;
     padding-inline-start: 12px;
     padding-bottom: 13px;
     padding-inline-end: 12px;
 }
 .heading-section{
     display: flex;
     align-items: center;
 }
 .update-message{
    flex-basis: 37%;
 }
 .action-button-section{
     flex: 1;
     text-align: end;
 }
 .center-pipe{
     display: inline-block;
     width: 28px;
     position: relative;
     text-align: center;
 }
 .center-pipe::before{
     position: absolute;
     content: "";
     top: 0;
     inset-inline-start: 0;
     width: 1px;
     height: 37px;
     background: #373737;
     transform: translate(11px,-23px);
 }
 .content-section{
     color: $info-color;
     // font-size: $info-font-size;
 }
 .update-msg{
     color: $dull-text-color;
 }
 </style>